"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var QdLogo = function QdLogo(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "1891.4px",
    height: "464.6px",
    viewBox: "0 0 1891.4 464.6"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1805.6,346.2c0,40.1-32.3,71.8-73.5,71.8c-41.2,0-73.5-31.7-73.5-71.8c0-40.3,32.3-72.2,73.5-72.2 C1773.3,274,1805.6,305.9,1805.6,346.2z M1771.6,346.2c0-23.7-17.1-41.2-39.5-41.2c-22.4,0-39.5,17.5-39.5,41.2 c0,23.5,17.1,40.8,39.5,40.8C1754.6,387,1771.6,369.7,1771.6,346.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M842.3,189.6c-3.9,0.6-8,1-12.3,1c-41.2,0-73.5-31.7-73.5-71.8c0-40.3,32.3-72.2,73.5-72.2c41.2,0,73.5,31.9,73.5,72.2 c0,23.3-10.9,43.6-28,56.8l35.8,46.9h-44.5L842.3,189.6z M830,159.6c22.4,0,39.5-17.3,39.5-40.8c0-23.7-17.1-41.2-39.5-41.2 c-22.4,0-39.5,17.5-39.5,41.2C790.5,142.3,807.5,159.6,830,159.6z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1063,125.4c0,39.5-24.5,65.2-61.1,65.2c-37.5,0-62.6-25.7-62.6-65.2V49.7h34v75.7c0,21,11.3,34,28.6,34 c16.3,0,27.2-13,27.2-34V49.7h34V125.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1200.3,187.5l-9.7-25.1h-58l-9.7,25.1h-36.4l57.6-137.9h34.8l57.6,137.9H1200.3z M1161.6,87.9l-17.5,45.3h35.2L1161.6,87.9 z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1358,187.5l-41.6-47.3h-9.9v47.3h-34V49.7h69.8c29.8,0,49.6,18.1,49.6,45.1c0,22.6-14,38.9-36.2,43.8l43.2,49H1358z M1338.7,111.8c12.1,0,20-6.6,20-16.7c0-9.9-7.8-16.5-20-16.5h-32.1v33.1H1338.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1495,79.3v108.3h-33.8V79.3h-44.7V49.7h123.1v29.6H1495z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1679.4,187.5H1572V49.7h106.8v29.2h-72.9v25.9h66.9v27.6h-66.9v25.9h73.5V187.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1804.7,187.5l-41.6-47.3h-9.9v47.3h-34V49.7h69.8c29.8,0,49.6,18.1,49.6,45.1c0,22.6-14,38.9-36.2,43.8l43.2,49H1804.7z M1785.4,111.8c12.1,0,20-6.6,20-16.7c0-9.9-7.8-16.5-20-16.5h-32.1v33.1H1785.4z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M811,277.1c45.5,0,75.5,28,75.5,68.9S856.5,415,811,415h-54.5V277.1H811z M809.8,385.5c25.7,0,42.6-15.6,42.6-39.5 s-16.9-39.5-42.6-39.5h-19.3v79H809.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1035.5,415H928V277.1h106.8v29.2H962v25.9h66.9v27.6H962v25.9h73.5V415z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1331.9,415l-36.2-52.7l-24.3,29V415h-34V277.1h34v68.1l57.4-68.1h38.5l-49.6,59.1l55.4,78.8H1331.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1449.5,397.5c0,10.5-8,18.5-18.9,18.5s-18.7-8-18.7-18.5c0-9.9,7.8-18.5,18.7-18.5S1449.5,387.6,1449.5,397.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1592.9,321.1c-7.1-9.9-18.5-16.1-31.8-16.1c-22.4,0-39.5,17.5-39.5,41.2c0,23.5,17.1,40.8,39.5,40.8 c15.3,0,28.1-8,34.7-20.6l20.5,27.6c-13.4,14.8-33,24-55.2,24c-41.2,0-73.5-31.7-73.5-71.8c0-40.3,32.3-72.2,73.5-72.2 c23.8,0,44.7,10.7,58,27.5L1592.9,321.1z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M1174.1,321.1c-7.1-9.9-18.5-16.1-31.8-16.1c-22.4,0-39.5,17.5-39.5,41.2c0,23.5,17.1,40.8,39.5,40.8 c15.3,0,28.1-8,34.7-20.6l20.5,27.6c-13.4,14.8-33,24-55.2,24c-41.2,0-73.5-31.7-73.5-71.8c0-40.3,32.3-72.2,73.5-72.2 c23.8,0,44.7,10.7,58,27.5L1174.1,321.1z"
  }), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M628.6,98.9C592.5,66.2,560.4,49.7,486,49.7H356.4c0,0,6.7,2.6,17.6,13.5c21,18.5,37.3,38.6,48.8,63 c26.6,0,46.2-0.7,47.1-0.7c25.1,0.2,43.7,1,55.4,3.5c24.8,4.5,42.9,13.9,54.7,28.6c17.5,22,26,46.7,26,75.5 c0,32.7-11.3,59.3-34.4,79c-21.4,18.6-48.5,28.2-81.8,28.2h-41.3v74.4h44.2c67.1,0,116.2-18.4,146.1-56.7 c30.5-38.9,45.7-79.3,45.7-125C684.5,176.5,665.8,133.3,628.6,98.9z M181.3,328.2c-28.2-11.4-49-34.7-60.4-69.9h-75 c9.8,56.9,34.1,97.5,73.1,122.9c34.1,22.2,81.3,33,142.5,33h141.4v-74.2H275.5C231.7,340.2,200.2,336.4,181.3,328.2z M348.5,98.6 c-36.8-32.5-78-48.8-124-48.8c-41.7,0-80.2,14.1-116.5,42.8c-36.3,28.2-56.9,68.1-62.3,121.8H121c10.8-55.8,47.7-88.2,103.5-88.2 c30.3,0,55.2,9.7,74.8,29.8c19.5,20,29.2,45,29.2,75.8c0,21.1-7,42.3-20.6,63.4h84.5c7.6-21.1,11.4-42.8,11.4-64.5 C403.7,175,385.3,131.1,348.5,98.6z"
  }))));
};
QdLogo.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
QdLogo.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = QdLogo;